export default {
  searchTemplate: {
    url: '/operationads/timePricing/searchTemplate',
    method: 'post',
    desc: '分时调价初始数据'
  },
  getShop: {
    url: '/operationads/timePricing/shop',
    method: 'post',
    desc: '分时调价初始数据'
  },
  getShopList: {
    url: '/operationads/timePricing/shop/list',
    method: 'post',
    desc: '分时调价初始数据'
  },
  detailsAdd: {
    url: '/operationads/timePricing/detailsAdd',
    method: 'post',
    desc: '分时调价添加模板-广告活动'
  },
  noticeModify: {
    url: '/operationads/timePricing/noticeModify',
    method: 'post',
    desc: '分时调价-通知设置'
  },
  templateStatus: {
    url: '/operationads/timePricing/templateStatus',
    method: 'post',
    desc: '分时调价模板状态'
  },
  detailsModify: {
    url: '/operationads/timePricing/detailsModify',
    method: 'post',
    desc: '分时调价编辑模板'
  },
  launcheList: {
    url: '/operationads/report/launche/list',
    method: 'post',
    desc: '分时调价使用模版分页-投放词'
  },
  setting: {
    url: '/operationads/timePricing/setting',
    method: 'post',
    desc: '分时调价模板修改'
  },
  templateDelete: {
    url: '/operationads/timePricing/templateDelete',
    method: 'post',
    desc: '分时调价模板删除'
  },
  getExecutePlan: {
    url: '/operationads/timePricing/getExecutePlan',
    method: 'post',
    desc: '分时调价预览'
  },
  getHistoryVersion: {
    url: '/operationads/timePricing/history/version',
    method: 'post',
    desc: '分时调价历史版本'
  },
  getHistory: {
    url: '/operationads/timePricing/history',
    method: 'post',
    desc: '分时调价-操作记录'
  },
  getTemplateList: {
    url: '/operationads/timePricing/getTemplateList',
    method: 'post',
    desc: '分时调价模板列表'
  },
  getExecuteResult: {
    url: '/operationads/timePricing/getExecuteResult',
    method: 'post',
    desc: '执行结果分页'
  },
  getExecuteDetails: {
    url: '/operationads/timePricing/getExecuteDetails',
    method: 'post',
    desc: '执行结果弹框'
  },
  getExecuteHistory: {
    url: '/operationads/timePricing/getExecuteHistory',
    method: 'post',
    desc: '执行结果-操作记录弹框'
  }
  // getExecuteHistory: {
  //   url: '/operationads/timePricing/getExecuteHistory',
  //   method: 'post',
  //   desc: '执行结果-操作记录弹框'
  // },
}
